import { Award, Heart, Target, Users, GraduationCap, Shield } from "lucide-react";

const aboutImage = "https://customer-assets.emergentagent.com/job_choice-omw-launch/artifacts/joyj41ji_IMG_5165.jpeg";

const highlights = [
  { icon: Shield, label: "U.S. Navy Veteran" },
  { icon: Award, label: "Navy Achievement Medal" },
  { icon: GraduationCap, label: "Faulkner University" },
  { icon: Users, label: "500+ Businesses Helped" },
];

const About = () => {
  return (
    <section id="about" className="py-20 lg:py-28 bg-background">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-br from-primary/10 via-gold/5 to-transparent rounded-3xl blur-xl" />
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img 
                src={aboutImage} 
                alt="LaVista Smith" 
                className="w-full h-auto object-cover"
              />
            </div>
            
            {/* Decorative quote */}
            <div className="absolute -bottom-6 -right-6 bg-primary text-primary-foreground p-6 rounded-2xl shadow-xl max-w-xs hidden md:block">
              <p className="font-display text-lg italic">
                "The hidden gem in Alabama that builds future leaders."
              </p>
            </div>
          </div>

          {/* Content */}
          <div>
            <div className="inline-flex items-center gap-2 text-primary mb-4">
              <span className="w-8 h-0.5 bg-primary rounded-full" />
              <span className="text-sm font-semibold uppercase tracking-wider">About Me</span>
            </div>

            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 leading-tight">
              Meet LaVista Smith
            </h2>

            <p className="text-lg text-muted-foreground leading-relaxed mb-6">
              A woman of great faith with a heart to truly see God's people blessed. An Alabama native, 
              I began my career of service in the <span className="text-foreground font-semibold">United States Navy</span>, 
              where I was recognized with the Navy Achievement Medal and served on the Navy Exchange System Strategic Planning Board.
            </p>

            <p className="text-lg text-muted-foreground leading-relaxed mb-6">
              After military service, I pursued education at Tidewater Community College and Faulkner University, 
              then managed successful businesses in retail, salon industry, cash operations, credit restoration, 
              and corporate bank operations management.
            </p>

            <p className="text-lg text-muted-foreground leading-relaxed mb-8">
              Today, I'm the founder of <span className="text-foreground font-semibold">WAVE</span> (women's support group), 
              <span className="text-foreground font-semibold"> One Made Whole</span> (singles ministry), 
              and <span className="text-foreground font-semibold">Safe Place Bible Study</span>. 
              I'm passionate about building and launching future leaders in small business and corporate America.
            </p>

            {/* Highlights */}
            <div className="grid grid-cols-2 gap-4">
              {highlights.map((item, index) => (
                <div 
                  key={index}
                  className="flex items-center gap-3 p-3 bg-muted/50 rounded-lg"
                >
                  <item.icon className="w-5 h-5 text-primary" />
                  <span className="text-sm font-medium text-foreground">{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
